/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */

import { Component } from 'llama'
import FaceDrawer from '../../common/FaceDrawer'
import FacePartSelector from './FacePartSelector'

export default class FacePartHair extends Component {
  constructor (opt) {
    super({
      ...opt,
      html: () => '<div id="part-choice-hair" class="part-choice square"></div>'
    })
  }

  init (params, path) {
    const { eventBus, context } = this

    const faceDrawer = new FaceDrawer()
    this.addChildren(
      params, path,

      new FacePartSelector({
        eventBus,
        context,
        box: 'part-choice-hair',
        num: 4,
        draw (ctx, i) {
          faceDrawer.drawHairOnly(ctx, i, 0.7, 15, { left: 10, top: 0 })
        },
        shape: 'hair',
        width: 90,
        height: 90
      })
    )
  }
}
